import { TEAM_TAB } from "src/consts/urlPaths";
import type { WorkspaceForecastRolloutFeatureFlags } from "src/workspace/workspaceFeatureFlags";
import { isForecastPositionViewEnabled } from "./isForecastPositionViewEnabled";

/** Forecast V8 needs forecast position view and its own rollout flag. */
export const isForecastV8Enabled = (
  flags: WorkspaceForecastRolloutFeatureFlags = {}
): boolean =>
  isForecastPositionViewEnabled(flags) && Boolean(flags.enableForecastV8);

/** Team tab for forecast deep links and nav remaps (Workforce when V8 is on). */
export const getForecastTeamTab = (
  flags: WorkspaceForecastRolloutFeatureFlags = {}
): string =>
  isForecastV8Enabled(flags) ? TEAM_TAB.WORKFORCE : TEAM_TAB.FORECAST;
